import React from 'react';
import {connect} from "react-redux";
import {baseNewImagesPath} from "../../../assets";
import {injectIntl} from "react-intl";
import config from "../canvas/store/sqftConfig";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../actions/sqftMenuFunctions";
import backsplashCanvas from "../canvas/core/controls/backsplashCanvas";

const SqftNavBacksplashesFeature = (props) => {
  const {intl, featureName, selectedBacksplash, setSelectedBacksplash} = props;

  const featureClick = (e, disallowDemo) => {
    setSelectedBacksplash(featureName);

    backsplashCanvas.setHighlighting(disallowDemo);
    backsplashCanvas.setBackSplashFeature({
      size: featureName,
      name: getBackSplashText(),
    });
    backsplashCanvas.setCursorImage();
    if (window.innerWidth < 991 && !config.tutorialIsRunning) {
      //todo sqft-react
      //Menu.hideSideBarContent(); // hide sidebar menu
    }
  };

  const getBackSplashText = () => {
    let subMenuText;
    // todo sqft-react metric message
    switch (featureName) {
      case "4":
        subMenuText = intl.formatMessage({id: "visualizer.kitchen.contextmenu.backsplash.4in"});
        break;
      case "6":
        subMenuText = intl.formatMessage({id: "visualizer.kitchen.contextmenu.backsplash.6in"});
        break;
      case "18":
        subMenuText = intl.formatMessage({id: "visualizer.kitchen.contextmenu.backsplash.18in"});
        break;
      case "wall":
        subMenuText = intl.formatMessage({id: "sqft.navigation.submenu.wall"});
        break;
      default:
        subMenuText = intl.formatMessage({id: "sqft.navigation.backsplashItem"});
        break;
    }

    return subMenuText
  };

  return (
    <li className={"lightbox-option-round lightbox-option-round--edge "+ ( selectedBacksplash === featureName ? "lightbox-option-selected" : "" )} onClick={featureClick}>
      <div className="lightbox-option-round lightbox-option-round--backsplash" data-id="4b" data-backsplash="4" data-name='4" Backsplash'
           data-name-metric='100mm Backsplash'>
        <div className="feature-thumbnail">
          <img className={"feature-thumbnail__image"}
               src={`${baseNewImagesPath}images/backsplash/backsplash-${featureName}.png`}
               alt=""/>
        </div>
        <div className="lightbox-option-round-loader-edge"/>
        <div className="lightbox-description-text" >
          <span>{getBackSplashText()}</span>
        </div>
      </div>
    </li>
  )
};

const mapStateToProps = () => {
  return {}
};

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavBacksplashesFeature)
)
